<template>
	<div class="image-props">
		IMAGE PROPS
		
        <div class="position-settings text-center">
			<label>Позиционирование</label>
            <div class="break"/>
                <btn @press='setProp({position:"top left"})' :active="value.position === 'top left'" iconSvg="top-left" />
                <btn @press='setProp({position:"top"})' :active="value.position === 'top'" iconSvg="up" />
                <btn @press='setProp({position:"top right"})' :active="value.position === 'top right'" iconSvg="top-right" />
            <div class="break"/>
                <btn @press='setProp({position:"left"})' :active="value.position === 'left'" iconSvg="left" />
                <btn @press='setProp({position:"center"})' :active="value.position === 'center'" icon="circle" :iconSize="16" />
                <btn @press='setProp({position:"right"})' :active="value.position === 'right'" iconSvg="right" />
            <div class="break"/>
                <btn @press='setProp({position:"bottom left"})' :active="value.position === 'bottom left'" iconSvg="bottom-left" />
                <btn @press='setProp({position:"bottom"})' :active="value.position === 'bottom'" iconSvg="down" />
                <btn @press='setProp({position:"bottom right"})' :active="value.position === 'bottom right'" iconSvg="bottom-right" />
        </div>

        <div>
        	<label>Размеры</label>
            <btn 
            	:key="size"
            	v-for="size in ['cover','contain','auto']" 
            	@press='setProp({size})' :active="value.size === size" 
            	:label="size"
            />
        </div>
	</div>
</template>

<script>
export default {

  name: 'image-props',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>